/** @jsxImportSource theme-ui */

import React from 'react';

import AuthForm from './AuthForm';

export type AuthVariant =
  | 'signin'
  | 'resetPassword'
  | 'confirmResetPassword'
  | 'self_web_signup'
  | 'confirmSignup'
  | 'qr-code'
  | 'business_login';

interface AuthBoxProps {
  confirmCode?: string;
  variant?: AuthVariant;
  referral?: string;
}

export default function AuthBox({
  confirmCode,
  variant = 'signin',
  referral = '',
}: AuthBoxProps) {
  const [currentVariant, setCurrentVariant] = React.useState(variant);

  return (
    <AuthForm
      confirmCode={confirmCode}
      referral={referral}
      variant={currentVariant}
      setCurrentVariant={setCurrentVariant}
    />
  );
}
